import { VisitSurvey } from '@/app/models/new-activity-creation-state'
import { VisitForm } from '@/app/models/new-activity-form'
import { NewActivitySectionType } from '@/app/models/new-activity-section-type'
import { ProjectApiCreateActivityBody } from '@/app/models/projects-service'
import { NotificationSourceModule, SmartlyActionItems } from '@Techedge/digitalportal-shared'

export const getCreateBodyRequest = (form: VisitForm, selectedSurveys: VisitSurvey[]) => {
    let badgeProps = {}
    if (!!form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.id) {
        badgeProps = {
            badgeId: form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value.id,
            badgeType: SmartlyActionItems.VISIT,
            badgeActivityPoints: form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value,
        }
    }
    return {
        projectType: SmartlyActionItems.VISIT,
        module: NotificationSourceModule.STORE_VISIT,
        type: SmartlyActionItems.VISIT,
        priority: 'standard',
        enableMessaging: false,
        requiredConfirmReading: false,
        autoclose: false,
        autocloseDate: form.scheduling.startDate.value.setHours(
            form.scheduling.endTime.value.getHours(),
            form.scheduling.endTime.value.getMinutes(),
            form.scheduling.endTime.value.getSeconds()
        ),
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        visibility: 'immediate',
        projectTitle: form.mainInfo.title.value,
        storesIdList: [form.mainInfo.storeId.value],
        information: form.mainInfo.info.value,
        attachments: form.mainInfo.attachmentList.value.map((a) => ({ _id: a.id || a._id })),
        surveysSvt: selectedSurveys.map((s: VisitSurvey) => ({ surveyId: s.surveyId })),
        remoteVisit: form.scheduling.remoteVisit.value,
        startDate: form.scheduling.startDate.value.setHours(
            form.scheduling.startTime.value.getHours(),
            form.scheduling.startTime.value.getMinutes(),
            form.scheduling.startTime.value.getSeconds()
        ),
        endDate: form.scheduling.startDate.value.setHours(
            form.scheduling.endTime.value.getHours(),
            form.scheduling.endTime.value.getMinutes(),
            form.scheduling.endTime.value.getSeconds()
        ),
        visibilityCalendar: form.scheduling.calendarVisibility.value,
        mysteryVisit: form.scheduling.mysteryVisit.value,
        ...badgeProps,
    }
}

export const getEditVisitBodyRequest = ({
    form,
    selectedSurveys,
    projectDetails,
}: {
    form: VisitForm
    selectedSurveys: VisitSurvey[]
    projectDetails: ProjectApiCreateActivityBody
}) => {
    const body: any = {
        ...getCreateBodyRequest(form, selectedSurveys),
        _id: projectDetails._id,
        coneOfVision: projectDetails.coneOfVision,
        storesList: [
            {
                storeId: form.mainInfo.storeId.value,
                storeName: form.mainInfo.storeName,
                status: form.mainInfo.storeStatus || 'new',
            },
        ],
        creatorUserInfo: projectDetails.creatorUserInfo,
        surveysSvt: selectedSurveys.map((s) => ({
            surveyId: s.surveyId,
            surveyName: s.surveyName,
            surveyUrl: s.surveyUrl,
            duration: s.duration,
        })),
        status: projectDetails.status,
        department: null,
        assignment: [],
        approverRequired: null,
    }
    delete body.storesIdList
    delete body.badge
    if (body.creatorUserInfo) {
        delete body.creatorUserInfo.nickname
    }
    return body
}
